import { BehaviorSubject } from 'rxjs';
import { postServiceRequest, ServiceRequest } from '../Api/ServiceRequest/serviceRequestApi';
import { getAccountScope } from './User';

const serviceRequestSubject = new BehaviorSubject<ServiceRequest[]>([]);

export const getServiceRequestSubject = (): BehaviorSubject<ServiceRequest[]> => serviceRequestSubject;

export const clearServiceRequestStore = () => {
  serviceRequestSubject.next([]);
};

export const addServiceRequest = async (service_request: ServiceRequest, accountId?: string) => {
  const currentValue = [...serviceRequestSubject.getValue()];

  const scope = getAccountScope();
  const fallbackAccountId = scope?.length === 1 ? scope[0]?.id : undefined;
  const resp = await postServiceRequest(service_request, accountId ?? fallbackAccountId);
  if (!resp.error) {
    const newRequest = resp.data;
    serviceRequestSubject.next([newRequest, ...currentValue]);
    return newRequest;
  } else {
    return;
  }
};
